import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { BiTematicaService } from '../services/bi-tematica.service';


@Injectable({
  providedIn: 'root'
})
export class BiTematicaResolver implements Resolve<boolean> {

  constructor(private service: BiTematicaService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}